export type ShareResourceType =
  | 'chat_attachment'
  | 'conversation'
  | 'remix_project'

export interface ShareCreatePayloadInput {
  resourceType: ShareResourceType
  resourceId: string
  brandId?: string
  expiresAt?: string
  password?: string
  snapshotMessageIds?: string[]
}

export interface ShareListQueryInput {
  resourceType: ShareResourceType
  resourceId: string
  brandId?: string
}

export function buildShareListQuery({
  resourceType,
  resourceId,
  brandId,
}: ShareListQueryInput): Record<string, string> {
  return {
    resource_type: resourceType,
    resource_id: resourceId,
    ...(brandId ? { brand_id: brandId } : { scope: 'org' }),
  }
}

export function buildShareCreatePayload({
  resourceType,
  resourceId,
  brandId,
  expiresAt,
  password,
  snapshotMessageIds,
}: ShareCreatePayloadInput): Record<string, unknown> {
  return {
    resource_type: resourceType,
    resource_id: resourceId,
    ...((resourceType === 'chat_attachment' ||
      resourceType === 'remix_project') &&
    brandId
      ? { brand_id: brandId }
      : {}),
    ...(resourceType === 'chat_attachment' && !brandId ? { scope: 'org' } : {}),
    ...(expiresAt ? { expires_at: expiresAt } : {}),
    ...(password ? { password } : {}),
    ...(resourceType === 'conversation' && snapshotMessageIds
      ? { snapshot_message_ids: snapshotMessageIds }
      : {}),
  }
}
